import { useTranslation } from "react-i18next";
import KeyboardReact, { KeyboardOptions } from "react-simple-keyboard";
import {
    getVirtualKeyboardAlphaButtons,
    getVirtualKeyboardLayouts,
} from "../helpers/virtualKeyboardLayouts";

import "react-simple-keyboard/build/css/index.css";
import "./CustomSimpleKeyboard.scss";

const CustomSimpleKeyboard = (props: KeyboardOptions) => {
    const {
        layoutName,
        theme,
        enterButtonText = "< enter", // or "return"
        backspaceButtonText = "⌫",   // or "backspace"
        shiftButtonText = "⇧",       // or "shift"
        clearButtonText = "Clear",
        disabled,
        languageCode,
        ...restProps
    } = props;

    const { t, i18n } = useTranslation();
    const activeLanguageCode = languageCode || i18n.resolvedLanguage || i18n.language;
    const layouts = getVirtualKeyboardLayouts(activeLanguageCode);
    const alphaButtons = getVirtualKeyboardAlphaButtons(activeLanguageCode);

    const display = {
        "{numbers}": "123",
        "{enter}": enterButtonText,
        "{escape}": "esc ⎋",
        "{space}": "␣",
        "{tab}": "tab",             // "tab ⇥",
        "{backspace}": backspaceButtonText,
        "{capslock}": "caps",       // "caps lock ⇪",
        "{shift}": shiftButtonText,
        "{controlleft}": "ctrl",    // "ctrl ⌃",
        "{controlright}": "ctrl",   // "ctrl ⌃",
        "{altleft}": "alt",         // "alt ⌥",
        "{altright}": "alt",        // "alt ⌥",
        "{metaleft}": "cmd ⌘",
        "{metaright}": "cmd ⌘",
        "{abc}": "ABC",
        "{numpaddecimal}": ".",
        // "{up}": "&Hat;",
        "{arrowup}": "&#9650;",
        "{arrowdown}": "&#9660;",
        "{clear}": clearButtonText,
        "{mobileKeyboard}": t("mobileKeyboard"),
    };
    
    const buttonTheme = [
        {
            class: "vk-alpha-key",
            buttons: alphaButtons
        },
        {
            class: "vk-space-key",
            buttons: "{space}"
        },
        {
            class: "vk-compact-punct-key",
            buttons: ", ."
        }
    ];

    return (
        <KeyboardReact
            layoutName={layoutName && layouts[layoutName] ? layoutName : "default"}
            layout={layouts}
            display={display}
            theme={`${disabled ? 'keyboard-disabled' : ''} ${theme}`}
            buttonTheme={buttonTheme}
            {...restProps}
        />
    );
};

export default CustomSimpleKeyboard;
